"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var financeSummaryStyles = makeStyles_1.default(function () { return ({
    wrapper: {
        padding: '20px 0 0 0',
    },
}); }, { name: 'Summary_FinanceSummary' });
exports.default = financeSummaryStyles;
